import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Plus, Folder, ArrowRight, ChatCircleText, ChartLineUp, Megaphone, Barbell, Buildings, CalendarDots, User, DotsThree } from "@phosphor-icons/react";
import { PageHeader } from "../components/ui/kaizen";

const THEMES = [
  { k: "finance", label: "Finance", icon: ChartLineUp, color: "#2A9D8F" },
  { k: "marketing", label: "Marketing", icon: Megaphone, color: "#D90429" },
  { k: "athletes", label: "Athlètes", icon: Barbell, color: "#2B2D42" },
  { k: "ecole", label: "École", icon: Buildings, color: "#E9C46A" },
  { k: "evenements", label: "Événements", icon: CalendarDots, color: "#6f42c1" },
  { k: "personnel", label: "Personnel", icon: User, color: "#6C757D" },
  { k: "autre", label: "Autre", icon: DotsThree, color: "#0A0A0A" },
];

export default function ProjectsModule() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", theme: "finance", instructions: "", color: "#D90429" });

  const load = () => api.get("/projects").then(r => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/projects", form);
      setForm({ name: "", theme: "finance", instructions: "", color: "#D90429" });
      setOpen(false); load();
      toast.success("Projet créé");
    } catch { toast.error("Erreur"); }
  };

  return (
    <div data-testid="projects-page">
      <div className="px-8 lg:px-12 pt-8">
        <PageHeader
          title="Dossiers"
          breadcrumbs={[{ label: "IA, système & support" }, { label: "Assistant IA" }]}
          subtitle="Crée un dossier par thème. Chaque dossier a sa mémoire, ses documents et son chat stratégique."
          actions={
            <button data-testid="proj-add-btn" onClick={() => setOpen(!open)} className="bg-[#D90429] hover:bg-[#BF0424] text-white px-5 py-2.5 rounded-lg text-sm flex items-center gap-2 transition-colors">
              <Plus size={14}/> {open ? "Annuler" : "Nouveau dossier"}
            </button>
          }
        />
      </div>

      {open && (
        <form onSubmit={create} className="hard-border-b px-8 lg:px-12 py-6 bg-secondary/30 grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="proj-form">
          <input data-testid="proj-name" required placeholder="Nom du dossier" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} className="hard-border px-3 py-2 md:col-span-2"/>
          <select data-testid="proj-theme" value={form.theme} onChange={(e)=>setForm({...form, theme:e.target.value})} className="hard-border px-3 py-2 bg-white">
            {THEMES.map(t => <option key={t.k} value={t.k}>{t.label}</option>)}
          </select>
          <textarea data-testid="proj-instructions" rows={3} placeholder="Instructions spécifiques (optionnel) — ex: 'Concentre-toi sur la fiscalité québécoise'" value={form.instructions} onChange={(e)=>setForm({...form, instructions:e.target.value})} className="hard-border px-3 py-2 md:col-span-3"/>
          <button data-testid="proj-submit" className="bg-foreground hover:bg-[#D90429] text-white py-2.5 ticker md:col-span-3 transition-colors">Créer le dossier</button>
        </form>
      )}

      <div className="px-8 lg:px-12 py-8">
        {list.length === 0 ? (
          <div className="hard-border p-12 text-center">
            <Folder size={48} weight="duotone" className="mx-auto text-muted-foreground mb-4"/>
            <div className="font-display text-xl font-bold">Aucun dossier</div>
            <div className="text-sm text-muted-foreground mt-1">Crée ton premier dossier pour démarrer un chat stratégique.</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 hard-border">
            {list.map((p, i) => {
              const theme = THEMES.find(t => t.k === p.theme) || THEMES[THEMES.length-1];
              const Icon = theme.icon;
              return (
                <Link key={p.id} to={`/app/dossiers/${p.id}`} data-testid={`proj-card-${i}`}
                  className={`p-6 group hover:bg-secondary/40 transition-colors ${i % 3 !== 2 ? 'md:border-r border-border' : ''} border-b border-border`}>
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 hard-border flex items-center justify-center" style={{ background: theme.color + "15", borderColor: theme.color + "50" }}>
                      <Icon size={22} weight="duotone" style={{ color: theme.color }}/>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-display font-bold text-lg truncate">{p.name}</div>
                      <div className="ticker text-muted-foreground">{theme.label}</div>
                      <div className="text-xs text-muted-foreground mt-2 line-clamp-2">{p.instructions || "Aucune instruction spécifique"}</div>
                    </div>
                    <ArrowRight size={16} className="text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity"/>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
